var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"src":_vm.videoUrl,"allowFullScreen":"","frameborder":"0","mozallowfullscreen":"","webkitAllowFullScreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }